<div *ngIf="isLocktonUser()">
  <mat-icon class="helpButton" (click)="onSupportIconClick()">help_outline</mat-icon>
</div>
